/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BranchWithNetSalesPerOrderAndOrderCount } from './BranchWithNetSalesPerOrderAndOrderCount';
import {
    BranchWithNetSalesPerOrderAndOrderCountFromJSON,
    BranchWithNetSalesPerOrderAndOrderCountFromJSONTyped,
    BranchWithNetSalesPerOrderAndOrderCountToJSON,
    BranchWithNetSalesPerOrderAndOrderCountToJSONTyped,
} from './BranchWithNetSalesPerOrderAndOrderCount';

/**
 * 
 * @export
 * @interface BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse
 */
export interface BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse {
    /**
     * 
     * @type {Array<BranchWithNetSalesPerOrderAndOrderCount>}
     * @memberof BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse
     */
    data: Array<BranchWithNetSalesPerOrderAndOrderCount>;
}

/**
 * Check if a given object implements the BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse interface.
 */
export function instanceOfBusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse(value: object): value is BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseFromJSON(json: any): BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse {
    return BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseFromJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(BranchWithNetSalesPerOrderAndOrderCountFromJSON)),
    };
}

export function BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseToJSON(json: any): BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse {
    return BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseToJSONTyped(json, false);
}

export function BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponseToJSONTyped(value?: BusinessReportBranchesWithNetSalesPerOrderAndOrderCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(BranchWithNetSalesPerOrderAndOrderCountToJSON)),
    };
}

